export default __webpack_public_path__ + "static/media/auth-bg.a32c6062.png";